import React from 'react';
import Chip from '@mui/material/Chip';
import { DoorCrewSeat } from './types';

interface EndingPickUpAssignedChipProps {
  seat: DoorCrewSeat;
}

export default function EndingPickUpAssignedChip({ seat }: EndingPickUpAssignedChipProps) {
  if (!seat.ending_pickup_lat || !seat.ending_pickup_lon || !seat.ending_pickup_address) {
    return null;
  }

  return (
    <Chip
      size="small"
      icon={<i className="fa fa-check-circle" />}
      label={seat.ending_pickup_address}
      color="success"
      variant="outlined"
      sx={{ mr: 0.5, mt: 0.25 }}
      title={seat.ending_pickup_address}
    />
  );
}
